/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FxIdWebFeaturesClientCommandsAckRequest,
  FxIdWebFeaturesClientCommandsAckResponse,
  FxIdWebFeaturesClientCommandsClaimResponse,
} from '../models/index';
import {
    FxIdWebFeaturesClientCommandsAckRequestFromJSON,
    FxIdWebFeaturesClientCommandsAckRequestToJSON,
    FxIdWebFeaturesClientCommandsAckResponseFromJSON,
    FxIdWebFeaturesClientCommandsAckResponseToJSON,
    FxIdWebFeaturesClientCommandsClaimResponseFromJSON,
    FxIdWebFeaturesClientCommandsClaimResponseToJSON,
} from '../models/index';

export interface FxIdWebFeaturesClientCommandsAckEndpointRequest {
    fxIdWebFeaturesClientCommandsAckRequest: FxIdWebFeaturesClientCommandsAckRequest;
}

/**
 * 
 */
export class ClientCommandsApi extends runtime.BaseAPI {

    /**
     * Подтверждает выполнение команд, ранее полученных через /claim. Проверяет lease_token и account_id для каждой команды.
     */
    async fxIdWebFeaturesClientCommandsAckEndpointRaw(requestParameters: FxIdWebFeaturesClientCommandsAckEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesClientCommandsAckResponse>> {
        if (requestParameters['fxIdWebFeaturesClientCommandsAckRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesClientCommandsAckRequest',
                'Required parameter "fxIdWebFeaturesClientCommandsAckRequest" was null or undefined when calling fxIdWebFeaturesClientCommandsAckEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/client_commands/ack`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesClientCommandsAckRequestToJSON(requestParameters['fxIdWebFeaturesClientCommandsAckRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesClientCommandsAckResponseFromJSON(jsonValue));
    }

    /**
     * Подтверждает выполнение команд, ранее полученных через /claim. Проверяет lease_token и account_id для каждой команды.
     */
    async fxIdWebFeaturesClientCommandsAckEndpoint(fxIdWebFeaturesClientCommandsAckRequest: FxIdWebFeaturesClientCommandsAckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesClientCommandsAckResponse> {
        const response = await this.fxIdWebFeaturesClientCommandsAckEndpointRaw({ fxIdWebFeaturesClientCommandsAckRequest: fxIdWebFeaturesClientCommandsAckRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Выдаёт клиенту доступные отложенные команды с установкой lease-токена. Аккаунт определяется по токену авторизации из запроса.
     */
    async fxIdWebFeaturesClientCommandsClaimEndpointRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesClientCommandsClaimResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/client_commands/claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesClientCommandsClaimResponseFromJSON(jsonValue));
    }

    /**
     * Выдаёт клиенту доступные отложенные команды с установкой lease-токена. Аккаунт определяется по токену авторизации из запроса.
     */
    async fxIdWebFeaturesClientCommandsClaimEndpoint(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesClientCommandsClaimResponse> {
        const response = await this.fxIdWebFeaturesClientCommandsClaimEndpointRaw(initOverrides);
        return await response.value();
    }

}
